import React, { Component, PropTypes } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    textAlign: 'center',
    // width: 5 * (44 + Units.base),
    margin: `0 auto ${Units.base * 2}px`,
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: '0.3px',
    color: Colors.fullWhite,
    '&leftAlign': {
      textAlign: 'left'
    }
  }
});

class FormFieldContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.node,
    leftAlign: PropTypes.bool
  };

  render() {
    const { children, title, leftAlign } = this.props;
    const classes = classNames(css.root, {
      [css.leftAlign]: leftAlign
    });
    return (
      <div className={classes}>
        <div>{title}</div>
        {children}
      </div>
    );
  }
}

export default FormFieldContainer;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/FormFieldContainer.js